import { combineReducers } from 'redux';
import { fileListSlice } from './list';
import { selectedSlice } from './selected';

export default combineReducers({
  [fileListSlice.name]: fileListSlice.reducer,
  [selectedSlice.name]: selectedSlice.reducer,
});
